var _ICONS;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { ZIndex } from '@tablekit/theme';
var ALERT_PORTAL_ID = 'alert_portal';
var Appearance;

(function (Appearance) {
  Appearance["Primary"] = "primary";
  Appearance["Success"] = "success";
  Appearance["Warning"] = "warning";
  Appearance["Danger"] = "danger";
})(Appearance || (Appearance = {}));

var Position;

(function (Position) {
  Position["Top"] = "top";
  Position["TopLeft"] = "top-left";
  Position["TopRight"] = "top-right";
  Position["Bottom"] = "bottom";
  Position["BottomLeft"] = "bottom-left";
  Position["BottomRight"] = "bottom-right";
})(Position || (Position = {}));

var ICONS = (_ICONS = {}, _defineProperty(_ICONS, Appearance.Danger, faExclamationCircle), _defineProperty(_ICONS, Appearance.Warning, faExclamationTriangle), _defineProperty(_ICONS, Appearance.Success, faCheckCircle), _defineProperty(_ICONS, Appearance.Primary, faInfoCircle), _ICONS);

var getWrapperBlockStyles = function getWrapperBlockStyles(position) {
  var _position$split = position.split('-'),
      _position$split2 = _slicedToArray(_position$split, 2),
      yPosition = _position$split2[0],
      xPosition = _position$split2[1];

  return "\n    position: fixed;\n    z-index: ".concat(ZIndex.Flag, ";\n    width: fit-content;\n    ").concat(yPosition, ": 3%;\n    ").concat(xPosition ? "".concat(xPosition, ": 3%;") : 'left: 50%; transform: translateX(-50%);', "\n  ");
};

var getClassByPosition = function getClassByPosition(position) {
  return "alert_manager_".concat(position);
};

export { ALERT_PORTAL_ID, Appearance, ICONS, Position, getClassByPosition, getWrapperBlockStyles };
